var cccApp = cccApp || {};
var zE = zE || undefined;

(function (app, zE) {
    "use strict";

    var storageVars = ["current-tab"];

    // Local Storage  & Cookie Utilities
    app.storage = (function () {

        var getLocalStorageItem = function(itemName) {
            if (window.localStorage) {
                return window.localStorage.getItem(itemName);
            } else {
                return undefined;
            }
        };

        var setLocalStorageItem = function(itemName, itemValue) {
            if (window.localStorage) {
                window.localStorage.setItem(itemName, itemValue);
            }
        };

        var clearLocalStorageItem = function(itemName) {
            if (window.localStorage) {
                window.localStorage.removeItem(itemName);
            }
        };

        var clearLocalStorage = function() {
            if (window.localStorage) {
                for (var i = 0; i < storageVars.length; i++) {
                    window.localStorage.removeItem(storageVars[i]);
                }
            }
        };

        var readCookie = function(name) {
            var nameEq = name + "=";
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === " ") c = c.substring(1, c.length);
                if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
            }
            return null;
        }

        var deleteCookie = function (name) {
            if (document.cookie.indexOf(name) >= 0) {
                document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT";
            }
        }

        return {
            get: getLocalStorageItem,
            set: setLocalStorageItem,
            clear: clearLocalStorageItem,
            purge: clearLocalStorage,
            readCookie: readCookie,
            deleteCookie: deleteCookie
        };
    }());

    // Utilities
    app.utils = (function() {

        var reloadPage = function () {
            if (window.jQuery) {
                var activeTabs = $("li.tab-item.active[data-tab]");
                var tabsValue = [];

                for (var i = 0; i < activeTabs.length; i++) {
                    tabsValue.push($(activeTabs[i]).data("tab"));
                }

                if (typeof cccApp !== "undefined" && cccApp.storage) {
                    cccApp.storage.set("current-tab", tabsValue.join(","));
                }
            }

            document.location.reload(true);
        };

        var getReturnUrlParam = function (name, includeHashPath) {
            includeHashPath = (typeof includeHashPath === "boolean") ? includeHashPath : false;

            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(window.location.href);

            if (results === null)
                return null;
            else {
                var result = results[1];

                if (includeHashPath) {
                    if (result.indexOf("#") !== -1 || result.indexOf("%23") !== -1) {
                        return result;
                    } else {
                        return result + window.location.hash;
                    }
                } else {
                    return result;
                }
            }
        };

        var urlPortion = function (portionIndex) {
            var parts = window.location.pathname.split("/");

            if (parts.length > (portionIndex + 1)) {
                return "";
            } else {
                return parts[portionIndex];
            }
        }

        var getQueryStringValue = function (key) {
            var values = [];
            var target = location.href;

            key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");

            var pattern = key + "=([^&#]+)";
            var oReg = new RegExp(pattern,"ig");
            while (true) {
                var matches = oReg.exec(target);
                if(matches && matches[1]){
                    values.push(decodeURIComponent(matches[1]));
                } else {
                    break;
                }
            }

            if (!values.length) {
                return null;   
            } else {
                return values.length === 1 ? values[0] : values;
            }
        }

        var initZendeskWidget = function () {
            if (typeof (window.zE) !== "undefined") {
                window.zE(function() {
                    window.zE.hide();
                });
            }
        };

        var openZendeskWidget = function () {

            if (cccApp.clientSystem.browser === "Internet Explorer" 
                && (cccApp.clientSystem.browserMajorVersion <= 9)) {

                if (cccApp.settings.zendeskUrl) {
                    window.open(cccApp.settings.zendeskUrl, "_blank");
                } else {
                    window.open("//support.ccleanercloud.com/hc/en-us", "_blank");
                }
            }
            else {
                if (typeof (window.zE) !== "undefined") {
                    if (typeof (cccApp.user) !== "undefined" && cccApp.tier) {
                        window.zE.identify({
                            name: cccApp.user.fullName() || cccApp.user.displayName(),
                            email: cccApp.user.email(),
                            externalId: cccApp.user.id,
                            organization: "CCleaner Cloud " + cccApp.tier.description
                        });
                    }

                    window.zE.activate({ hideOnClose: true });
                }
            }
        }

        var isNullOrWhitespace = function (input) {

            if (typeof input === 'undefined' || input === null) return true;

            return input.replace(/\s/g, '').length < 1;
        }

        var toTitleCase = function (str) {
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        }

        var htmlEncode = function (input) {
            var element = document.createElement("div");
            element.innerText = input;
            var textValue = element.innerHTML;
            return textValue;
        }

        var removeHtml = function (input) {
            var elem = document.createElement("div");
            elem.innerHTML = input.replace(/&/g, "&amp;");
            var textValue = elem.innerText;
            return textValue;
        }

        var decimalLength = function (num) {
            var splitted = (num + "").split(".");
            if (splitted[1] != null) {
                return splitted.length;
            }

            return 0;
        }

        var addCommas = function(nStr) {
            nStr += "";
            var x = nStr.split(".");
            var x1 = x[0];
            var x2 = x.length > 1 ? "." + x[1] : "";
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, "$1" + "," + "$2");
            }
            return x1 + x2;
        }

        var startsWith = function (str, startsWith) {
            str = str || "";

            if (!startsWith || startsWith.length > str.length) {
                return false;
            }

            return str.substring(0, startsWith.length) === startsWith;
        };

        return {
            reloadPage: reloadPage,
            getUrlParam: getReturnUrlParam,
            getUrlPortion: urlPortion,
            getQueryStringValue: getQueryStringValue,
            initZendeskWidget: initZendeskWidget,
            openZendeskWidget: openZendeskWidget,
            isNullOrWhitespace: isNullOrWhitespace,
            toTitleCase: toTitleCase,
            htmlEncode: htmlEncode,
            removeHtml: removeHtml,
            decimalLength: decimalLength,
            addCommas: addCommas,
            startsWith: startsWith
        };

    }());

    // UI
    app.ui = (function() {

        var changeUserMenuState = function() {
            if ($(".main-menu").hasClass("none")) {
                $(".menu-underlay").fadeIn().removeClass("none");
                $(".main-menu").slideDown(300, function() {
                    $(this).removeClass("none").removeAttr("style");
                });
                $(".main-menu-icon").addClass("close-btn");
                $(".main-menu-drop").addClass("menu-collapse");
                $("body").addClass("no-scroll");
            } else {
                $(".menu-underlay").fadeOut().addClass("none");
                $(".main-menu").slideUp(300, function() {
                    $(".menu-underlay").removeAttr("style");
                    $(this).addClass("none").removeAttr("style");
                });
                $(".main-menu-icon").removeClass("close-btn");
                $(".main-menu-drop").removeClass("menu-collapse");
                $("body").removeClass("no-scroll");
            }
        };

        var closeUserMenu = function() {
            if ($(".main-menu").is(":visible")) {
                changeUserMenuState();
            }
        };

        var selectTab = function(element, pageTitle, koObj, renderCompleteCallback) {

            if (pageTitle) {
                document.title = pageTitle;
            }

            if (!koObj) {
                koObj = ko;
            }

            if (typeof renderCompleteCallback !== "function") {
                renderCompleteCallback = null;
            }

            cccApp.msg.clear("global-messages");

            if (typeof element === "string") {
                element = $("li[data-tab='" + element + "']");
            } else if (typeof element === "object") {
                element = $(element);
            } else {
                element = null;
            }

            if (element) {

                var componentName = element.attr("data-tab");

                var tabContent = $(".tab-content[data-tab-content='" + componentName + "']");

                // Make the next default sub-tab active
                var subTab = tabContent.find("nav > ul > .tab-item[data-tab-default]");

                if (subTab && subTab.length > 0) {
                    var subTabName = $(subTab[0]).attr("data-tab");
                    selectTab(subTabName, null, null);
                }

                var tab = undefined;
                var componentDef = undefined;
                var componentDefs = window.componentDefs;

                //Change Active State
                if (tabContent && componentName) {

                    if (typeof componentDefs !== "undefined" && componentDefs !== null) {
                        componentDef = componentDefs.filter(function(obj) {
                            return obj.id === componentName;
                        });

                        if (cccApp.models && componentDef && componentDef.length > 0 && componentDef[0].viewModel) {
                            tab = cccApp.models[componentDef[0].viewModel];
                        }
                    }

                    if (element.hasClass("active")) {

                        if (tab && typeof tab.render === "function") {
                            renderComponent({
                                initialize: false,
                                viewmodel: tab,
                                errorMessage: "Sorry, there was a problem while showing this tab",
                                complete: renderCompleteCallback
                            });
                            return;
                        }
                    }

                    //Select Tab Item
                    element.siblings(".tab-item").removeClass("active");

                    element.siblings(".tab-item").find(".tab-icon").removeClass("selected");
                    element.addClass("active");
                    element.find(".tab-icon").addClass("selected");

                    //Save current active state using data-tab-default and de-'active' previous tabs and sub-tabs 
                    element.attr("data-tab-default", "");
                    element.siblings(".tab-item").removeAttr("data-tab-default");
                    tabContent.siblings(".tab-content").children(".tab-item").removeClass("active");

                    //Fade In Tab
                    tabContent.siblings(".tab-content").addClass("none").removeAttr("style");

                    var queueContainer = $("#main-content");

                    queueContainer.queue("tab-nav", function () {
                        tabContent.fadeIn(500, function () {

                            var totalWidth = 0;

                            element.parent().find(".tab-item").each(function () {
                                totalWidth += parseInt($(this).outerWidth(), 10);
                            });

                            var viewportWidth = $(window).width();

                            var menuOuter = element.parent();

                            var currentPosition = 0;

                            if (element.offset().left < 0) {
                                while (!menuOuter.is("body") && !menuOuter.hasClass("menu-swipe-outer")) {
                                    menuOuter = menuOuter.parent();
                                }

                                if (!menuOuter.is("body")) {
                                    currentPosition = menuOuter.scrollLeft();
                                    cccApp.ui.smoothScroll(menuOuter, { scrollLeft: currentPosition + element.offset().left });
                                }
                            } else if ((element.offset().left + element.outerWidth()) > viewportWidth) {
                                while (!menuOuter.is("body") && !menuOuter.hasClass("menu-swipe-outer")) {
                                    menuOuter = menuOuter.parent();
                                }

                                if (!menuOuter.is("body")) {
                                    currentPosition = menuOuter.scrollLeft();
                                    var scrollToPosition = Math.floor(currentPosition + (element.offset().left - $(window).width()) + element.width());
                                    cccApp.ui.smoothScroll(menuOuter, { scrollLeft: scrollToPosition });
                                }
                            } else if (viewportWidth < 992 && totalWidth > viewportWidth) {
                                setTimeout(function () {
                                    cccApp.ui.bounceElement($(element.parent()), 3, 20, "right", 1000);
                                }, 500);
                            }
                        });
                        tabContent.siblings(".tab-content").children(".tab-item").removeClass("active");
                        tabContent.siblings(".tab-content").addClass("none").removeAttr("style");
                        tabContent.removeClass("none");
                        $(this).dequeue("tab-nav");
                    }).dequeue("tab-nav");

                    //Load Tab Content
                    if (componentDef && componentDef[0]) {

                        if (cccApp.models) {
                            tab = cccApp.models[componentDef[0].viewModel];
                        }

                        if (tab) {
                            renderComponent({
                                initialize: false,
                                viewmodel: tab,
                                errorMessage: "Sorry, there was a problem while loading this tab",
                                complete: renderCompleteCallback
                            });
                        } else {
                            loadComponent(koObj, componentDef[0].id, componentDef[0].container, componentDef[0].viewModel, componentDef[0].path, componentDef[0].html, componentDef[0].js, componentDef[0].renderAsKOComponent, componentDef[0].require, renderCompleteCallback);
                        }
                    }
                }
            }
        };

        var selectNestedTab = function(tabIds, pageTitle, renderCompleteCallback) {

            if (pageTitle) {
                document.title = pageTitle;
            }

            if (typeof (tabIds) === "string") {
                tabIds = [tabIds];
            }

            if (typeof renderCompleteCallback !== "function") {
                renderCompleteCallback = null;
            }

            if (typeof (tabIds) === "object") {
                for (var t = 0; t < tabIds.length; t++) {
                    $("li[data-tab='" + tabIds[t] + "']").attr("data-tab-default", "").siblings(".tab-item").removeAttr("data-tab-default");
                }

                selectTab(tabIds[0], null, null, renderCompleteCallback);
            }

            cccApp.closePopup();
        };

        var isTabSelected = function(element) {
            if (typeof element === "string") {
                element = $("li[data-tab='" + element + "']");
            } else if (typeof element === "object") {
                element = $(element);
            } else {
                element = null;
            }

            return element && element.hasClass("active");
        };

        var bounceElement = function (element, times, distance, direction, speed) {

            if (element.hasClass("bounced")) {
                return;
            }

            var increment = distance;
            var marginStyle = "marginLeft";

            if (direction === "up") {
                marginStyle = "marginBottom";
            } else if (direction === "down") {
                marginStyle = "marginTop";
            } else if (direction === "left") {
                marginStyle = "marginRight";
            }

            var animateCloseSettings = {};
            animateCloseSettings[marginStyle] = 0;
            var animateSettings = {};
            animateSettings[marginStyle] = distance;

            element.animate(animateSettings, { duration: speed, easing: "easeInOutCirc" }).animate(animateCloseSettings, { duration: speed, easing: "easeOutBounce" });

            element.addClass("bounced");
        };

        var openTooltip = function (element) {
            $("#" + element).addClass("open");
        };

        var closeTooltip = function (element) {

            // If no element was passed in
            if (typeof (element) === "undefined") {
                // Close all open tooltips
                $(".notif-tooltip .open").removeClass("open");
            }

            $("#" + element).removeClass("open");
        };

        var isEllipsisMenuOpen = function(menuId) {
            var element = $("#" + menuId);
            return typeof element === "object" && $(".ellipsis-menu-container", element).is(":visible");
        }

        var toggleEllipsisMenu = function (menuId) {
            var element = $("#" + menuId);

            if (!isEllipsisMenuOpen(menuId)) {
                var menuWidth = $(".ellipsis-menu-container", element).width();
                var leftPos = element.offset().left;
                if ((leftPos - menuWidth) < 0) {
                    $(".ellipsis-menu-container", element).css("left", (leftPos * -1) + "px");
                }
                $(".ellipsis-menu-icon", element).addClass("active");
                $(".ellipsis-menu-container", element).slideDown(300);
            } else {
                $(".ellipsis-menu-container", element).slideUp(300, function () { $(this).css("left", ""); });
                $(".ellipsis-menu-icon", element).removeClass("active");
            }
        }

        var closeAllEllipsisMenus = function () {
            $(".ellipsis-menu-container").slideUp(300, function() { $(this).css("left", ""); });
            $(".ellipsis-menu-icon").removeClass("active");
        }

        var smoothScroll = function(element, options) {
            if (!element || !options || (isNaN(options.scrollLeft) && isNaN(options.scrollTop))) {
                return;
            }

            var jElement = element instanceof jQuery ? element : $(element);
            var animateOptions = {};
            var speed = 100;
            if (!isNaN(options.scrollLeft)) {
                animateOptions.scrollLeft = options.scrollLeft;
            }

            if (!isNaN(options.scrollTop)) {
                animateOptions.scrollTop = options.scrollTop;
                speed = options.scrollTop > jElement.scrollTop() ? 300 : 200;
            }

            jElement.animate(animateOptions, speed);
        };

        var scrollInHorizontal = function(element) {
            if (!element) {
                return;
            }

            var jElement = $(element);
            var listContainer = jElement.parent();
            
            while (!listContainer.is("body") && !(
                listContainer.hasClass("scroll-list-h")
                || listContainer.hasClass("sm-scroll-list-h")
                || listContainer.hasClass("md-scroll-list-h")
                || listContainer.hasClass("lg-scroll-list-h"))) {
                listContainer = listContainer.parent();
            }

            if (!listContainer.is("body") && listContainer.css("overflow-x") === "scroll") {
                var currentPosition = listContainer.scrollLeft();
                var elementLeftEdge = Math.ceil(jElement.position().left);

                if (elementLeftEdge < 0) {
                    smoothScroll(listContainer, { scrollLeft: currentPosition + elementLeftEdge });
                } else {
                    var elementRightEdge = elementLeftEdge + jElement.outerWidth();
                    if (elementRightEdge > listContainer.width()) {
                        var scrollToPosition = Math.floor(currentPosition + elementRightEdge - listContainer.width());
                        smoothScroll(listContainer, { scrollLeft: scrollToPosition });
                    }
                }
            }
        };

        var scrollInVertical = function(element) {
            if (!element) {
                return;
            }

            var jElement = $(element);
            var listContainer = jElement.parent();

            while (!listContainer.is("body") && !(
                listContainer.hasClass("scroll-list")
                || listContainer.hasClass("sm-scroll-list")
                || listContainer.hasClass("md-scroll-list")
                || listContainer.hasClass("lg-scroll-list"))) {
                listContainer = listContainer.parent();
            }

            if (!listContainer.is("body") && listContainer.css("overflow-y") === "scroll") {
                var currentPosition = listContainer.scrollTop();
                var elementTopEdge = Math.ceil(jElement.position().top);

                if (elementTopEdge < 0) {
                    smoothScroll(listContainer, { scrollTop: currentPosition + elementTopEdge });
                } else {
                    var elementBottomEdge = elementTopEdge + jElement.outerHeight();
                    if (elementBottomEdge > listContainer.height()) {
                        var scrollToPosition = Math.floor(currentPosition + elementBottomEdge - listContainer.height());
                        smoothScroll(listContainer, { scrollTop: scrollToPosition });
                    }
                }
            }
        }

        var registerNavHeightEqualizer = function(iconNavId, subMenuId) {
            cccApp.ui.equalizeIconNavHeight(iconNavId, subMenuId);
            cccApp.clientSystem.window.addResizeCallback(iconNavId, subMenuId);
        }

        var equalizeIconNavHeight = function(iconNavId, subMenuId, offset) {

            offset = offset || 0;

            var iconNavElement = $("#" + iconNavId);
            var subMenuElement = $("#" + subMenuId);

            if (iconNavElement.length > 0 && subMenuElement.length > 0) {

                if (!subMenuElement.is(":visible")) {
                    return;
                }

                iconNavElement.css("height", "auto");
                subMenuElement.css("height", "auto");
                $("#" + iconNavId + " li:last-child").removeClass("icon-nav-terminator");

                var iconNavHeight = iconNavElement[0].getBoundingClientRect().height ? iconNavElement[0].getBoundingClientRect().height : 0;
                var subMenuHeight = subMenuElement[0].getBoundingClientRect().height > 0 ? subMenuElement[0].getBoundingClientRect().height : 0;

                if (iconNavHeight && subMenuHeight) {
                    if (iconNavHeight > subMenuHeight) {
                        subMenuElement.height(iconNavHeight - subMenuElement.css("padding-top").replace("px", "") + offset);
                    }
                    if (subMenuHeight > iconNavHeight) {
                        iconNavElement.height(subMenuHeight - iconNavElement.css("padding-top").replace("px", "") + offset);
                        $("#" + iconNavId + " li:last-child").addClass("icon-nav-terminator");
                    }
                    return;
                }
            }
        }

        var cancelEqualizedHeight = function (firstId, secondId) {

            var firstElement = $("#" + firstId);
            var secondElement = $("#" + secondId);

            if (firstElement && secondElement) {
                firstElement.css("height","auto");
                secondElement.css("height","auto");
            }
        }

        var indeterminateBarsInProgress = [];
        var incrementIndeterminateProgressBar = function(barId, reset) {

            reset = typeof reset === "boolean" ? reset : true;
            var bar = $("#" + barId + " .pb-indeterminate:visible");

            if (!bar || bar.length === 0) {
                indeterminateBarsInProgress[barId] = false;
                return;
            }

            var left = 1;
            var barWidth = bar.css("width");
            var width = $(".progress-bar:visible", bar).css("width");

            if (!reset) {
                left = $(".progress-bar", bar).css("left");
            } else if (indeterminateBarsInProgress[barId]) {
                return;
            }

            if (barWidth && left && width) {
                indeterminateBarsInProgress[barId] = true;
                barWidth = parseInt(barWidth);
                left = parseInt(left);
                width = parseInt(width);

                if (left + width <= (barWidth + width)) {
                    left += 5;
                    $(".progress-bar", bar).animate({ "left": left + "px" },
                        30,
                        function() {
                            incrementIndeterminateProgressBar(barId, false);
                        });
                } else {
                    $(".progress-bar", bar).css("left", (width * -1) + "px");
                    incrementIndeterminateProgressBar(barId, false);
                }
            } else {
                indeterminateBarsInProgress[barId] = false;
            }
        }

        return {
            toggleUserMenu: changeUserMenuState,
            closeUserMenu: closeUserMenu,
            isEllipsisMenuOpen: isEllipsisMenuOpen,
            toggleEllipsisMenu: toggleEllipsisMenu,
            closeAllEllipsisMenus: closeAllEllipsisMenus,
            selectTab: selectTab,
            selectNestedTab: selectNestedTab,
            isTabSelected: isTabSelected,
            bounceElement: bounceElement,
            openTooltip: openTooltip,
            closeTooltip: closeTooltip,
            scrollIntoViewHorizontal: scrollInHorizontal,
            scrollIntoViewVertical: scrollInVertical,
            smoothScroll: smoothScroll,
            startInderminateProgressBar: incrementIndeterminateProgressBar,
            registerNavHeightEqualizer: registerNavHeightEqualizer,
            equalizeIconNavHeight: equalizeIconNavHeight,
            cancelEqualizedHeight: cancelEqualizedHeight
        };
    }());

    // Dates
    app.dates = (function() {
        
        var convertCDateFormatToMomentFormat = function (formatString) {
            var a = ["d", "dd", "D", "DD", "o", "oo", "m", "mm", "M", "MM", "y", "yy"];
            var b = ["D", "DD", "ddd", "dddd", "DDD", "DDDD", "M", "MM", "MMM", "MMMM", "YY", "YYYY"];
            var res = formatString.replace(new RegExp(a.join('|'), "g"), function (c) {
                return b[a.indexOf(c)];
            });
            return res;
        };

        var convertCTimeFormatToMomentFormat = function (formatString) {
            var a = ["tt"];
            var b = ["a"];
            var res = formatString.replace(new RegExp(a.join("|"), "g"), function (c) {
                return b[a.indexOf(c)];
            });
            return res;
        };

        var initializeMoment = function (user) {
            if (typeof moment !== "undefined") {
                var timeFormat = "hh:mma";

                if (typeof user !== "undefined" && user) {
                    timeFormat = convertCTimeFormatToMomentFormat(user.timeFormat);
                }

                moment.updateLocale("en", {
                    calendar: {
                        lastDay: "[Yesterday] LT",
                        sameDay: "[Today] LT"
                    },
                    longDateFormat: {
                        LT: timeFormat
                    }
                });
            }
        };

        var stdTimezoneOffset = function() {
            var jan = new Date(this.getFullYear(), 0, 1);
            var jul = new Date(this.getFullYear(), 6, 1);
            return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        };

        var dst = function(date) {
            return date.getTimezoneOffset() < stdTimezoneOffset();
        };

        var addMinutes = function(date, minutes) {
            return new Date(date.getTime() + minutes * 60000);
        };

        var addHours = function(date, hours) {
            return new Date(date.getTime() + hours * 3600000);
        };

        var addDays = function(date, days) {
            var dat = new Date(date.valueOf());
            dat.setDate(dat.getDate() + days);
            return dat;
        };

        var difference = function(from, to) {

            var diff = to - from;

            if (diff < 0) {
                return "";
            }

            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            var hours = Math.floor(diff / (1000 * 60 * 60));

            if (days > 0) {
                if (days === 1) {
                    return "1 day";
                } else {
                    return days.toString() + " days";
                }
            } else if (hours > 0) {
                if (hours === 1) {
                    return "1 hour";
                } else {
                    return hours.toString() + " hours";
                }
            } else {
                var minutes = Math.floor(diff / (1000 * 60));

                if (minutes === 0) {
                    return "a few seconds";
                } else if (minutes === 1) {
                    return "1 minute";
                } else {
                    return minutes.toString() + " minutes";
                }
            }
        };

        var toCsTicks = function(jsTicks) {
            return (jsTicks * 10000) + 621355968000000000;
        };

        var toJsTicks = function(csTicks) {
            // Convert to JS date, since C# has ticks since 01-01-0001
            return (csTicks - 621355968000000000) / 10000;
        };

        var formatDate = function(dateValue, userTimeZone, showSeconds) {
            var timeZoneOffset = (typeof userTimeZone !== "undefined") ? userTimeZone : (cccApp.user && (typeof cccApp.user.timeZone !== "undefined")) ? cccApp.user.timeZone : 0; //in minutes
            var secondsFormat = (typeof showSeconds === "boolean" && showSeconds) ? ":ss" : "";
            timeZoneOffset = timeZoneOffset * 60 * 1000; // in milliseconds
            var mdateTZ = moment.utc(new Date(dateValue + timeZoneOffset));

            return mdateTZ.format(cccApp.user.momentDateTimeFormat() + secondsFormat);
        };

        return {
            convertCDateFormatToMomentFormat: convertCDateFormatToMomentFormat,
            convertCTimeFormatToMomentFormat: convertCTimeFormatToMomentFormat,
            dst: dst,
            addMinutes: addMinutes,
            addHours: addHours,
            addDays: addDays,
            initializeMoment: initializeMoment,
            diff: difference,
            toCsTicks: toCsTicks,
            toJSTicks: toJsTicks,
            formatDate: formatDate
        };
    }());

    // Numbers
    app.numbers = (function () {

        var toPercentage = function (value, precision, appendSign) {
            precision = isNaN(precision) ? 0 : Math.max(0, precision);
            appendSign = typeof (appendSign) === "boolean" ? appendSign : true;
            var precisionMultiple = Math.pow(10, precision);
            value = isNaN(value) ? 0 : Math.max(0, Math.min(100, value));
            value = (Math.floor(value * precisionMultiple) / precisionMultiple).toFixed(precision);

            return appendSign ? value + "%" : value;
        }

        var toByteSize = function (bytes, precision, toHtmlFormat, removeSpaces) {
            bytes = typeof (bytes) !== "undefined" ? bytes : 0;
            toHtmlFormat = typeof (toHtmlFormat) === "boolean" ? toHtmlFormat : true;
            removeSpaces = typeof (removeSpaces) === "boolean" ? removeSpaces : false;
            precision = isNaN(precision) ? -1 : parseInt(precision);

            var sizeLabels = ["B", "KB", "MB", "GB", "TB", "PB", "EB"];
            var i = 0;
            var size = bytes;
            while (size >= 1024 && i < sizeLabels.length - 1) {
                i++;
                size = size / 1024;
            }

            if (precision < 0) {
                if (size < 10) {
                    precision = 2;
                } else if (size < 100) {
                    precision = 1;
                } else {
                    precision = 0;
                }

                if (precision > 0 && size % 1 < Math.pow(10, -precision)) {
                    precision = 0;
                }
            }

            return size.toFixed(precision) + (removeSpaces ? "" : (toHtmlFormat ? "&nbsp;" : " ")) + sizeLabels[i];
        };

        var toKBSize = function (bytes, toHtmlFormat) {
            // Switch formatting on by default
            bytes = typeof (bytes) !== "undefined" ? bytes : 0;
            toHtmlFormat = typeof (toHtmlFormat) === "boolean" ? toHtmlFormat : true;
            var val = (Math.ceil(bytes / 1024.0).toFixed(0));
            return toHtmlFormat ? cccApp.utils.addCommas(val) + "&nbsp;KB" : val;
        };

        return {
            toByteSize: toByteSize,
            toKBSize: toKBSize,
            toPercentage: toPercentage
        };
    }());

}(cccApp, zE));

$(document).mousedown(function (event) {

    // Close any open menus, ellipsis menus or tooltips
    if ($(event.target).closest(".main-menu").length === 0 &&
        $(event.target).closest(".main-menu-icon").length === 0 &&
        $(event.target).closest(".main-menu-drop").length === 0) {
        cccApp.ui.closeUserMenu(false);
    }

    if ($(event.target).closest(".ellipsis-menu").length === 0 &&
        $(event.target).closest(".ellipsis-menu-icon").length === 0 &&
        $(event.target).closest(".ellipsis-menu-container").length === 0) {
        cccApp.ui.closeAllEllipsisMenus();
    }

    if ($(".notif-tooltip .open").length > 0 && $(event.target).closest(".notif-tooltip").length === 0) {

        if (cccApp.models && typeof cccApp.models === "object") {

            for (var model in cccApp.models) {
                if (cccApp.models.hasOwnProperty(model)) {
                    if (typeof cccApp.models[model].closeTooltip === "function") {
                        cccApp.models[model].closeTooltip();
                    }
                }
            }
        }
    }
});